module.exports = __webpack_public_path__ + "img/next-arrow.e6cb9ec7.svg";